// Custom elements


// Shared product-section swap, used by both the colour swatch links and the
// fabric switcher. Fetches the target product's rendered section and swaps it in
// place — preserving scroll position — then re-initialises the PDP.
const productSectionCache = {};
const productSectionLoaded = {};

function prefetchProductSection(link, sectionId) {
	if (!link) return Promise.resolve('');
	if (productSectionCache[link]) return productSectionCache[link];
	productSectionCache[link] = fetch(`${link}?section_id=${sectionId}`).then(resp => resp.text());
	productSectionCache[link].then(() => { productSectionLoaded[link] = true; });
	return productSectionCache[link];
}

async function swapProductSection({ link, sectionId, title, image, colour, productId, currentSwatchItem }) {
	let section = document.getElementById(`shopify-section-${sectionId}`);
	if (!section) return;

	if (!productSectionLoaded[link]) {
		section.classList.add('loading');

		if (window.productImagesLightbox) window.productImagesLightbox.destroy();

		if (image) document.querySelectorAll('.product__media img').forEach(m => m.src = image);
		if (colour && document.querySelector('.current_selected_color')) document.querySelector('.current_selected_color').innerText = colour;
		if (title && document.querySelector('.product__title')) document.querySelector('.product__title').innerText = title;

		if (currentSwatchItem && document.querySelector('.current-swatch')) {
			document.querySelector('.current-swatch').classList.remove('current-swatch');
			currentSwatchItem.classList.add('current-swatch');
		}
	}

	history.replaceState({}, undefined, link);
	if (title) document.title = `${title} – Bed Threads`;

	// Update canonical URL
	let canonical = document.querySelector('link[rel="canonical"]');
	if (canonical) canonical.href = window.location.href.replace(window.location.search, '');

	let data = await prefetchProductSection(link, sectionId);

	let template = document.createElement('template');
	template.innerHTML = data;

	const existingKlaviyoForm = document.getElementById('pdp-klaviyo-form');

	// Direct child only: the Buy More & Save rows sit inside the form too, and
	// their checked radios would otherwise be restored onto the new product.
	const selectedOptions = [...document.querySelectorAll('.product-form > variant-selector input[type="radio"]:checked')].map(el => el.value);
	let newSection = template.content;

	// Capture the section's rendered height so the layout doesn't collapse
	// while blocks like Nosto/Tolstoy re-hydrate for the new product.
	const preservedSectionHeight = section.offsetHeight;

	section.replaceWith(newSection);

	const newKlaviyoForm = document.getElementById('pdp-klaviyo-form');
	if (existingKlaviyoForm && newKlaviyoForm) newKlaviyoForm.replaceWith(existingKlaviyoForm);

	initProductPage();
	window.initSignifier();
	if (window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();

	for (let selectedOption of selectedOptions) {
		let radio = document.querySelector(`.product-form > variant-selector input[type="radio"][value="${selectedOption}"]`);
		if (radio) {
			radio.checked = true;
			radio.dispatchEvent(new Event('change', { bubbles: true }));
		}
	}

	// The restore above only reaches the main form, and the sticky bar ignores
	// the untrusted events it fires, so hand it the selection directly.
	document.querySelector('sticky-add-to-cart')?.syncFromPdp();

	// Hold the section's previous height until the new content has re-hydrated,
	// so the page below it doesn't jump during the swap.
	reserveHeight(document.getElementById(`shopify-section-${sectionId}`), preservedSectionHeight);

	// Reload other sections
	for (let otherSection of document.querySelectorAll('.shopify-section')) {
		if (otherSection.id.includes('okendo-reviews-widget') || otherSection.id.includes('nosto') || otherSection.classList.contains('reload-section')) {
			const resp = await fetch(`${link}?section_id=${otherSection.id.replace('shopify-section-', '')}`);
			otherSection.outerHTML = await resp.text();
		}
	}

	// Replace Nosto tagging if present
	const existingTagging = document.querySelector('.nosto_product');

	if (existingTagging) {
		const resp = await fetch(`${link}?view=blank`);
		const html = await resp.text();
		const doc = new DOMParser().parseFromString(html, 'text/html');

		const newTagging = doc.querySelector('.nosto_product');
		if (newTagging) existingTagging.outerHTML = newTagging.outerHTML;
	}

	if (window.okeWidgetApi) {
			window.okeWidgetApi.initAllWidgets()
	}

	if (window.nostojs && productId) {
		window.nostojs(api => {
			api.createRecommendationRequest({includeTagging:true})
			.setProducts([{product_id: productId}])
			.load();
		});
	}
}

// Reserve a minimum height on an element until its content has re-hydrated
// enough to fill the space, so the layout below it doesn't collapse/jump.
function reserveHeight(el, height) {
	if (!el || !height) return;

	el.style.minHeight = `${height}px`;

	let released = false;
	const release = () => {
		if (released) return;
		released = true;
		clearTimeout(timer);
		observer.disconnect();
		el.style.minHeight = '';
	};

	const check = () => {
		if (released) return;
		// Measure natural height with the reservation lifted; only clear it for
		// good once the content fills it, so there's no visible shrink first.
		el.style.minHeight = '';
		const natural = el.offsetHeight;
		if (natural >= height) release();
		else el.style.minHeight = `${height}px`;
	};

	const observer = new MutationObserver(() => requestAnimationFrame(check));
	observer.observe(el, { childList: true, subtree: true });

	const timer = setTimeout(release, 8000);
}

window.prefetchProductSection = prefetchProductSection;
window.swapProductSection = swapProductSection;

if (!customElements.get('swatch-link')) {
	class SwatchLink extends HTMLElement {
		constructor() {
			super();
			this.sectionId = document.getElementById('ProductSection-product-template').dataset.sectionId;
			this.init();
		}

		async init() {
			this.addEventListener('mousedown', () => this.loadData());
			this.addEventListener('touchstart', () => this.loadData());
			this.addEventListener('click', e => {
				e.preventDefault();
				this.swap();
			});

			this.addEventListener('mouseenter', () => this.correctTooltipOverflow());
			this.addEventListener('mouseleave', () => {
				const tooltip = this.querySelector('.tooltip_item');
				if (tooltip) {
					tooltip.style.transform = '';
					tooltip.style.removeProperty('--arrow-offset');
				}
			});

			window.addEventListener('load', this.loadData());
		}

		correctTooltipOverflow() {
			const tooltip = this.querySelector('.tooltip_item');
			if (!tooltip) return;
			tooltip.style.transform = '';
			tooltip.style.removeProperty('--arrow-offset');
			requestAnimationFrame(() => {
				const rect = tooltip.getBoundingClientRect();
				const overflowRight = rect.right - (window.innerWidth - 16);
				const overflowLeft = -rect.left;
				if (overflowRight > 0) {
					tooltip.style.transform = `translate(calc(-50% - ${overflowRight}px))`;
					tooltip.style.setProperty('--arrow-offset', `${overflowRight}px`);
				} else if (overflowLeft > 0) {
					tooltip.style.transform = `translate(calc(-50% + ${overflowLeft}px))`;
					tooltip.style.setProperty('--arrow-offset', `-${overflowLeft}px`);
				}
			});
		}

		loadData() {
			return prefetchProductSection(this.dataset.link, this.sectionId);
		}

		swap() {
			return swapProductSection({
				link: this.dataset.link,
				sectionId: this.sectionId,
				title: this.dataset.title,
				image: this.dataset.image,
				colour: this.dataset.colour,
				productId: this.dataset.productId,
				currentSwatchItem: this.closest('.product-swatch__item'),
			});
		}
	}

	customElements.define('swatch-link', SwatchLink);
}

if (!customElements.get('details-toggle')) {
	class DetailsToggle extends HTMLElement {
		constructor() {
			super();

			this.addEventListener('click', e => {
				let details = this.previousElementSibling;

				if (details.classList.contains('expanded')) this.close();
				else this.open();
			});
		}

		open() {
			let details = this.previousElementSibling;
			details.classList.add('expanded');
			this.classList.add('expanded');
			details.style.maxHeight = `${details.scrollHeight}px`;
		}

		close() {
			let details = this.previousElementSibling;
			details.classList.remove('expanded');
			this.classList.remove('expanded');
			details.style.maxHeight = '';
		}
	}

	customElements.define('details-toggle', DetailsToggle);
}


class CartCount extends HTMLElement {
	constructor() {
		super();
		this.lastUpdate = null;
		
		const observer = new IntersectionObserver(entries => {
			if (entries.some(e => e.isIntersecting)) {
				this.init();
				observer.disconnect();
			}
		});

		observer.observe(this);
	}

	init() {
		const atcObserver = new PerformanceObserver(async list => {
			if (list.getEntries().some(entry => entry.initiatorType === "fetch" && entry.name.match(/\/cart\/(add).js/))) {
				setTimeout(() => this.update(), 2000);
			}
		});

		atcObserver.observe({ entryTypes: ["resource"] });

		let refreshHandle = null;
		const viewportObserver = new IntersectionObserver(entries => {
			if (entries.some(e => e.isIntersecting)) {
				if (!this.lastUpdate || Date.now() - this.lastUpdate > 60000) this.update();
				if (refreshHandle) clearInterval(refreshHandle);
				refreshHandle = setInterval(() => this.update(), 60000);
			}
			else {
				if (refreshHandle) clearInterval(refreshHandle);
				refreshHandle = null;
			}
		});

		viewportObserver.observe(this);
	}

	async update() {
		// Hidden for a sold-out variant (WEB-3154) — skip the fetch until it's
		// back, and leave the display to CSS rather than an inline override.
		if (this.hidden) return;

		const handle = this.getAttribute('handle');
		if (!handle) return;

		const resp = await fetch(`https://cart-count.bedthreads.workers.dev/count?handle=${handle}`);
		const count = await resp.json();

		this.lastUpdate = Date.now();

		if (count < 20) {
			this.style.display = 'none';
			return;
		}

		this.innerHTML = `🔥 In ${count} carts right now`;
		this.setAttribute('loaded', '');
		this.style.display = '';
		this.liftWidthCap();
	}

	/* Fills the count in after a hidden spell skipped its fetch, so switching
	   off a sold-out variant doesn't leave it blank until the next refresh. */
	reveal() {
		if (!this.hasAttribute('loaded')) this.update();
	}

	/* The reveal animates max-width, which can't animate to auto, so the count
	   is capped at a four-digit width while it expands. Drop the cap once that
	   finishes — otherwise a wider-than-expected count stays clipped. */
	liftWidthCap() {
		if (this.dataset.revealed !== undefined) return;
		this.dataset.revealed = '';

		const reveal = () => {
			this.classList.add('is-revealed');
			this.removeEventListener('transitionend', onTransitionEnd);
		};

		const onTransitionEnd = e => {
			if (e.propertyName === 'max-width') reveal();
		};

		this.addEventListener('transitionend', onTransitionEnd);
		// Nothing to wait for when the transition never runs — reduced motion,
		// or the bar re-created while already scrolled past.
		setTimeout(reveal, 500);
	}
}

customElements.define('cart-count', CartCount);


const initProductPage = () => {
	// Add to cart
	const addToCart = async () => {
		let select = document.getElementById('ProductSelect-product-template');
		let quantity = 1;
		let option = select.selectedOptions[0];
		let selectedSku = select.selectedOptions[0].getAttribute('data-sku');

		const atcButton = document.getElementById('AddToCart-product-template');
		atcButton.classList.add('loading', 'show-loading', 'show-loading--inverted');
		
		// Remove any existing error messages
		const existingErrorMessage = document.querySelector('.add-to-cart-error');
		if (existingErrorMessage) {
			existingErrorMessage.remove();
		}

		let preOrderNote = document.getElementById('preorder-note');
		let preOrderMonth = preOrderNote && preOrderNote.value.length > 0 ? preOrderNote.dataset.month : null;

		let props = {};

		const handle = option.dataset.productHandle;
		const customProps = Object.entries(window.theme.customProps).find(([key, value]) => handle.includes(key))?.[1];
		if (customProps) props = {...props, ...customProps };

		if (option.dataset.priceTest == "true" && window.getActivePriceTest()) props['_PriceTest'] = window.getActivePriceTest();

		// Selling plan
		const checkedSellingPlanGroup = document.querySelector('.product__selling-plan-group input:checked ~ .product__selling-plan-content select');
		const sellingPlan = checkedSellingPlanGroup ? checkedSellingPlanGroup.selectedOptions[0].value : null;

		const items = [{
			handle: handle,
			variantId: option.value,
			quantity: quantity,
			isBundle: theme.product.isBundle,
			preorderMonth: preOrderMonth,
			properties: props,
			sellingPlan
		}];

		// Nothing from "Buy More & Save" goes in here: each of its rows is added
		// by its own Add button, so this button buys the product being viewed and
		// nothing else (WEB-3220).

		const inCart = window.theme.cartItems?.find(item => item.variant_id == option.value);
		const limited = inCart && option.dataset.inventory && inCart.quantity >= parseInt(option.dataset.inventory) && parseInt(option.dataset.inventory) > 0;

		// Before the line is sent, so Buy More & Save has stopped moving this
		// product's price with the cart by the time the add lands (WEB-3267)
		if (!limited) window.dispatchEvent(new CustomEvent('pdp:addingtocart'));

		const errorMessage = limited ? "All available inventory is already in cart" : await addAllToCart(items);
		
		if (errorMessage) {
			// Display error message
			const errorElement = document.createElement('div');
			errorElement.className = 'add-to-cart-error';
			errorElement.innerHTML = errorMessage;
			
			// Insert error message above the add to cart button
			const quantityItem = document.querySelector('.product-form__item--quantity');
			quantityItem.before(errorElement);
			
			atcButton.classList.remove('loading', 'show-loading', 'show-loading--inverted');
			return;
		}
		
		let stickyCloseOverlay = document.querySelector('.close_menu_overlay');
		if (stickyCloseOverlay && getComputedStyle(stickyCloseOverlay).display != 'none') {
			stickyCloseOverlay.click();
		}
		
		if ((window.featureEnabled && window.featureEnabled('show-cart')) || window.innerWidth > 992) {
			await window.updateCartDrawer();
			window.showCartDrawer(true);
		} else {
			window.updateCartDrawer();
			window.showCartDrawer();
		}

		window.dispatchEvent(new CustomEvent('pdp:addtocart', { bubbles: true, composed: true }));

		atcButton.classList.remove('loading', 'show-loading', 'show-loading--inverted');
		
		if (selectedSku.includes('BT-SWATCHCARD')) {
			const atcButton = document.getElementById('AddToCart-product-template');
			atcButton.innerHTML = 'Already in cart';
			atcButton.disabled = true;
		}
	}

	const addToCartButton = document.getElementById('AddToCart-product-template');

	addToCartButton?.addEventListener('click', async e => {
		// Disable if link
		if (e.target.type != "submit" && e.target.type != "button") return;
		e.preventDefault();
		await addToCart();
	});

	if (addToCartButton) addToCartButton.dataset.loaded = true;

	// The whole-basket add — this product plus everything ticked in Buy More &
	// Save — published on the button so the sticky bar can place the same order
	// rather than adding this product on its own.
	if (addToCartButton) addToCartButton.addToCart = addToCart;

	// Buy button
	let buyButton = document.getElementById('BuyButton-product-template');
	if (buyButton) {
		buyButton.addEventListener('click', async e => {
			// Disable if link, or if gift card (separate script handles ATC for that)
			if (e.target.type != "submit" || theme.product.type.includes('Gift Card')) return;
			e.preventDefault();
			let select = document.getElementById('ProductSelect-product-template');
			let quantity = 1;
			let option = select.selectedOptions[0];

			e.currentTarget.classList.add('show-loading');

			let preOrderNote = document.getElementById('preorder-note');
			let preOrderMonth = preOrderNote && preOrderNote.value.length > 0 ? preOrderNote.dataset.month : null;

			let props = {};

			let items = await buildCartItems({handle: option.dataset.productHandle, variantId: option.value, quantity: quantity, isBundle: theme.product.isBundle, preOrderMonth: preOrderMonth, props: props});
			await window.theme.buyNow(items);
		});
	}

	const variantSelector = document.querySelector('.product-form variant-selector');

	if (variantSelector) variantSelector.preorderAtc = addToCart;
	if (variantSelector) variantSelector.addEventListener('variantchange', e => {
		console.log('variant change', e.target);

		// Remove any existing error messages when variant changes
		const existingErrorMessage = document.querySelector('.add-to-cart-error');
		if (existingErrorMessage) {
			existingErrorMessage.remove();
		}

		const selector = e.target;
		const variant = e.detail.variant;	
		const wrapper = selector.closest('.product-main-wrapper');

		// Set variant ID in URL
		const params = new URLSearchParams(window.location.search);
		params.set('variant', variant.id);
		window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);

		// Update price text. Addressed by its own class, not as the lockup's last
		// span — the Final Sale tooltip sits after it, so the last span isn't the
		// price. Buy More & Save re-prices the span inside this one afterwards,
		// off the document-level variant:change that follows this handler.
		let priceText = variant.priceText;
		document.querySelector('.product__price-text').innerHTML = priceText;
       
		// Update loyalty points pill
		const pointsPill = document.querySelector('.points-pill');
		if (pointsPill) pointsPill.dataset.price = variant.price;

		// Update express shipping pill
		const expressPill = document.querySelector('.points-pill--express');
		if (expressPill) expressPill.style.display = variant.status !== 'available' && variant.status !== 'low-stock' ? 'none' : '';

		// Set wishlist button variant
		let wishlistButtons = document.querySelectorAll('.product-main-wrapper wishlist-add-button');
		for (let wishlistButton of wishlistButtons) {
			wishlistButton.dataset.variant = variant.id;
		}

		// Update the Includes accordion (WEB-3151). Only bundles render #inclusions
		// — their pieces change with the size chosen — so everything else keeps
		// the list it was rendered with.
		const inclusionsContainer = wrapper.querySelector('#inclusions');
		if (inclusionsContainer) {
			const variantInclusionsData = JSON.parse(inclusionsContainer.dataset.variantInclusions || '[]');
			const variantData = variantInclusionsData.find(v => v.id == variant.id);

			if (variantData) {
				const inclusionsBlock = inclusionsContainer.querySelector('.product__variant-inclusions');
				if (inclusionsBlock) inclusionsBlock.innerHTML = variantData.content;
			}
		}

		// Select correct image
		if (variant.image) {
			const thumb = document.querySelector(`.product__thumbnail[data-src="${variant.image}"]`);
			if (thumb) thumb.click();
		}

		// Update preorder/sold out state
		const addToCart = document.getElementById('AddToCart-product-template');

		if (addToCart.dataset.limited != 'true') { // Don't update status if quantity limited, eg loyalty gift
			addToCart.disabled = false;

			const shippingUsp = wrapper.querySelector('.product-usp--shipping');
			if (shippingUsp) shippingUsp.style.display = '';

			const bisForm = wrapper.querySelector('.product__bis-form');
			if (bisForm) {
				bisForm.style.display = 'none';
				bisForm.querySelector('bis-form').setAttribute('variant', variant.id);
			}

			const preorderNoteInput = wrapper.querySelector('#preorder-note');
			preorderNoteInput.value = '';

			if (variant.status == 'sold-out' || variant.status == 'preorder' || variant.status == 'coming-soon') {
				if (shippingUsp) shippingUsp.style.display = 'none';

				if (variant.status == 'coming-soon') {
					addToCart.innerHTML = 'Coming soon';
					addToCart.disabled = true;
				}
				else if (variant.status == 'sold-out') {
					addToCart.innerHTML = 'Sold out';
					addToCart.disabled = true;
					if (bisForm && variant.restocking == "true") bisForm.style.display = '';
				}
				else {
					addToCart.innerHTML = 'Pre-Order Now';
					preorderNoteInput.dataset.month = variant.preorderMonth;
					preorderNoteInput.value = preorderNoteInput.dataset.template.replace('$month', variant.preorderMonth);
					if (bisForm) bisForm.style.display = '';
				}
			}
			else {
				addToCart.innerHTML = 'Add to Cart';
			}

			// The promise under the ATC names the pre-order month in place of the
			// 1-2 day window, and drops out when there's nothing to promise at all
			// (WEB-3153). Either string can be blank if the merchant cleared it.
			const fulfilmentNote = wrapper.querySelector('.product-form__fulfilment__note');
			if (fulfilmentNote) {
				let note = fulfilmentNote.dataset.promise || '';

				if (variant.status == 'preorder') {
					note = (fulfilmentNote.dataset.preorderPromise || '').replace('[month]', variant.preorderMonth || '');
				}
				else if (variant.status == 'sold-out' || variant.status == 'coming-soon') {
					note = '';
				}

				// Drives the availability dot's colour — amber for pre-order, like
				// the variant selector (WEB-3153).
				fulfilmentNote.dataset.variantStatus = variant.status || '';
				fulfilmentNote.querySelector('.product-form__fulfilment__note-text').textContent = note;
				fulfilmentNote.hidden = note == '';
			}

			// Both counts (title row and under the ATC) sit out sold out (WEB-3154).
			const soldOut = variant.status == 'sold-out';
			for (const count of wrapper.querySelectorAll('cart-count')) {
				count.hidden = soldOut;
				if (!soldOut) count.reveal?.();
			}
		}

		// Restocking tag
		wrapper.dataset.restocking = variant.restocking;

		// Discount tag
		const discountTag = wrapper.querySelector('.product__flag-tag--discount');
		if (discountTag && variant.discountTag) discountTag.innerHTML = variant.discountTag;

		// Final sale tooltip
		const clearanceTooltip = wrapper.querySelector('.pdp_tooltip-container');
		if (clearanceTooltip) {
			if (variant.finalSale == 'true') clearanceTooltip.style.display = '';
			else clearanceTooltip.style.display = 'none';
		}
	});

	// product-template-js.liquid + product-js-files.liquid
	(() => {
		// PDP Redesign JS
		$(function () {
			// okendo review
			let totalReviewCount = $('.okeReviews-reviewsAggregate-summary-total').text();
			let getNumbersCount = totalReviewCount.replace(/\D/g, '');

			$('.okeReviews-reviewsAggregate-summary-total').text(`(${getNumbersCount})`);

			// Okendo swatch reload fix
            if (window.okeWidgetApi) {
                window.okeWidgetApi.initAllWidgets()
            }
		});
	})();
}

initProductPage();
